/* eslint-disable */
import * as DateHelper from '../helpers/date'
import _ from 'lodash'


const GREETINGS = [
  'Good day, XXX 👋',
  'Greetings 👋',
  'Hi, XXX 👋',
  'Hello, XXX 👋',
  'Hey, XXX 👋',
  'Welcome, XXX ❤️',
  'G’day, XXX! ',
  'Bonjour, XXX 🥖',
  'Salut, XXX 👋',
  'Olá, XXX 🤍❤️💙',
  'Ciao, XXX 🤏',
  'Ahoj, XXX 🤍',
  'Hi, XXX 🌈',
  'Hello, how’s your day? 🖖',
  'Greetings, XXX, how are things going? 🏖',
  'Konnichiwa, XXX 🎎',
  'Hey, XXX, how’s it going? 🧭',
  'Hello, XXX, good to see you 👋',
  'Namaste, XXX, how are things going? 🏖',
  'Hi, XXX, how are you doing? 🧭',
  'Hi, XXX, it’s nice to see you again 🤖',
  'Hello, XXX, how are you doing today? 💪',
  'Ahoj, XXX, how have you been? 💪',
  'Hey, XXX, how is life sailing? 🏴‍☠️',
  'Hola, XXX, how’s your day? 🖖',
  'Hi, XXX, how’s your day going? 💪',
  'Good day, XXX, how are you doing? 🧭',
  'XXX, it’s great to see you! 🤖',
  'Hi, XXX! How’s everything? ❤️',
  'Howdy, XXX, good to see you 🤖',
  'Ciao, XXX, how’s it going? 🧭',
  'Hi, XXX, let’s make this day awesome 📚',
  'Hello, XXX, dreams are waiting ☄️',
  'Hey, XXX, how’s it going? 🐼',
  'Namaste, XXX, you can do it! 🚀',
  'Hey, XXX, I believe in you 🤖',
  'Good day, XXX, today is your day! ☄️',
  'Hello, XXX, plant a seed today 🌱',
  'Namaste XXX, adventure awaits 🌎',
  'XXX, prove them wrong! 🚀',
  'Hello, XXX, one day at a time 💪',
  'Hey XXX, you can totally do this! 🌟',
  'Hello, XXX, good things take time 💙',
  'Hey, XXX, you are awesome! 🤗',
  'Hi, XXX, check your posture 🤗',
  'Hey, you! You are astonishing! 😎',
  'XXX, make someone smile today 🤭',
  'Good day, 🐛🔜🦋',
  'Hi, XXX, look up and get lost 🪐',
  'XXX, enjoy the universe today 🌌',
  'Hello, XXX, today is full of possibilities🎨',
  'XXX, let today be a start of something new 🌄',
  'Good day, XXX, what good thing will you do today? 📖',
  'Greetings, XXX, what can you improve today? ⚖️',
  'Welcome, XXX, make today count 🌈',
  'XXX, today is your day! 🧠'
]

const ICONS = [
  'icon-hearth',
  'icon-headphones',
  'icon-sunrise',
  'icon-star',
  'icon-smile'
]

const COLORS = [
  '#000000',
  '#3D3270',
  '#424CE2',
  '#2196F3',
  '#9C28B1',
  '#E91D62',
  '#F34336',
  '#FFB800',
  '#21C228',
]

const plu = (text, count, singular, plural) => {
  if (count === 0) {
    return null
  } else if (count === 1) {
    return _.replace(_.replace(text, '_COUNT_', 'one'), plural, singular)
  } else {
    return _.replace(text, '_COUNT_', count)
  }
}

const getMessage = (getters) => {
  // if (getters.atLeastVisits(3) && !getters.user.reviewCreated && DateHelper.isMonday()) {
  //   return 'Don\'t forget to reflect on your progress on the <strong>My Journey</strong> page. Be truthful to yourself, and results will come.'
  // } else if (DateHelper.isSunday()) {
  //   return 'How\'s your week? Good? And how will next week be? Reflect and grow inside <strong>My Journey</strong> page with our <strong>Reflection Tool</strong>.'
  // }

  if (getters.user.lastActiveDay < DateHelper.daysAgo(14)) {
    return 'It’s a pleasure to see you again! How long has it been? You don’t have to be great to start, but you have to start to be great.'
  }

  if (getters.user.lastActiveDay < DateHelper.daysAgo(14)) {
    return 'It’s a pleasure to see you again! How long has it been? You don’t have to be great to start, but you have to start to be great.'
  }

  if (getters.overdueTasks.length > 0) {
    return plu('You have _COUNT_ overdue tasks.', getters.overdueTasks.length, 'task', 'tasks')
     // Also you have X tasks, X routines and X goals planned for today.`
  }

  if (getters.todayTasks.length > 0 || getters.activeUrgentRoutines.length > 0) {
    return 'You have ' + _.join(_.compact([
      plu('_COUNT_ tasks', getters.todayTasks.length, 'task', 'tasks'),
      plu('_COUNT_ routines', getters.activeUrgentRoutines.length, 'routine', 'routines')
    ]), ' and ') + ' planned for today.'
  } else {
    return 'No actions planned for today yet.'
  }
}

export default ({ notify, getters, lastActiveDay }) => {
  if (!lastActiveDay) {
    return
  }

  if (DateHelper.areEqual(
      DateHelper.midnight(lastActiveDay),
      DateHelper.midnightToday())) {
    return
  }

  const userName = (getters.userFirstName == 'Unregistered' || !getters.userFirstName) ? 'Achiever' : getters.userFirstName
  const greeting = _.replace(_.sample(GREETINGS), 'XXX', userName)

  notify({
    time: 8000,
    title: greeting,
    text: getMessage(getters),
    iconPack: 'feather',
    icon: _.sample(ICONS),
    color: _.sample(COLORS),
  })
}
